import { render, staticRenderFns } from "./TestSearch.vue?vue&type=template&id=375c5f7b&scoped=true&"
import script from "./TestSearch.vue?vue&type=script&lang=js&"
export * from "./TestSearch.vue?vue&type=script&lang=js&"
import style0 from "./TestSearch.vue?vue&type=style&index=0&id=375c5f7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375c5f7b",
  null
  
)

export default component.exports